var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._b(
      {
        attrs: { width: "500px", center: true, "show-close": false },
        on: {
          close: function ($event) {
            return _vm.$emit("update:visible", false)
          },
        },
      },
      "el-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "m_logo" }, [
        _c("img", {
          attrs: { src: require("@/assets/app_logo.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "m_code" }, [
        _c("img", { attrs: { src: require("@/assets/erCode.png"), alt: "" } }),
      ]),
      _c("div", { staticClass: "m_text" }, [_vm._v("扫码下载科普中国APP")]),
      _c("div", { staticClass: "m_label" }, [
        _c("span", [_c("i", { staticClass: "i_left" })]),
        _vm._v(" 开启您的智慧生活 "),
        _c("span", [_c("i", { staticClass: "i_right" })]),
      ]),
      _c(
        "div",
        {
          staticClass: "m_btn",
          on: {
            click: function ($event) {
              return _vm.$emit("update:visible", false)
            },
          },
        },
        [_vm._v("关闭")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }